import { Button } from "@mui/material";
import { useState } from "react";
import LedgerItemDialog from "../modal/LedgerItemDialog";
import { Alert } from "@mui/material";
import useAsyncAction from "../../helperFunctions/useAsyncAction";

export default function DeleteButton({ buttonAction, dialogInfo }) {
  const [open, setOpen] = useState(false);
  const { pending, error, run, clearError } = useAsyncAction();

  let { postDelete } = buttonAction;

  let title = "Delete Item?";

  const handleClickOpen = () => {
    clearError();
    setOpen(true);
  };

  const actionButton = () => <>
    {error && <Alert severity="error">{error}</Alert>}
    <Button disabled={pending} onClick={() => run(async () => {
      await postDelete(dialogInfo);
      setOpen(false);
    })}>{pending ? "Deleting..." : "Confirm"}</Button>
  </>;

  return (
    <>
      <Button
        color="error"
        size="small"
        sx={{ ml: ".25rem" }}
        variant="contained"
        onClick={() => handleClickOpen()}
      >
        Delete Entry
      </Button>
      <LedgerItemDialog
        modalControl={{ open, setOpen: (value) => { if (!pending) setOpen(value); }, pending }}
        dialogData={{ title, dialogInfo }}
        button={{actionButton}}
      />
    </>
  );
}
